import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import React, { useEffect } from "react";
import MainLayout from "./MainLayout";

const Home = React.lazy(() => import("../../pages/home/Home"));
const ScreenReaderAccess = React.lazy(() => import("../../pages/screenReaderAccess/ScreenReaderAccess"));
const Sitemap = React.lazy(() => import("../../pages/sitemap/Sitemap"));
const Search = React.lazy(() => import("../../pages/search/Search"));
const LatestEvents = React.lazy(() => import("../../pages/latestEvents/LatestEvents"));
const LatestEventDetail = React.lazy(() => import("../../pages/latestEvents/LatestEventDetail"));
const PhotoGallery = React.lazy(() => import("../../pages/photoGallery/PhotoGallery"));
const PhotoGalleryDataListing = React.lazy(() => import("../../pages/photoGallery/PhotoGalleryDataListing"));
const PhotoGalleryDetail = React.lazy(() => import("../../pages/photoGallery/PhotoGalleryDetail"));
const VideoGallery = React.lazy(() => import("../../pages/videoGallery/VideoGallery"));
const PressReleases = React.lazy(() => import("../../pages/pressReleases/PressReleases"));
const PressReleaseDetail = React.lazy(() => import("../../pages/pressReleases/PressReleaseDetail"));
const CorporateSong = React.lazy(() => import("../../pages/corporateSong/CorporateSong"));
const Tenders = React.lazy(() => import("../../pages/tenders/Tenders"));
const TenderDetail = React.lazy(() => import("../../pages/tenders/TenderDetail"));
const Recruitment = React.lazy(() => import("../../pages/recruitment/Recruitment"));
const PenalAction = React.lazy(() => import("../../pages/penalAction/PenalAction"));
const DataListing = React.lazy(() => import("../../pages/dataListing/DataListing"));
const CardDataListing = React.lazy(() => import("../../pages/cardDataListing/CardDataListing"));
// const SafetyRescueDepartment = React.lazy(() => import("../../pages/safetyRescueDepartment/SafetyRescueDepartment"));
const Content = React.lazy(() => import("../../pages/content/Content"));
const Feedback = React.lazy(() => import("../../pages/feedback/Feedback"));
const Help = React.lazy(() => import("../../pages/help/Help"));
const NotFound = React.lazy(() => import("../../pages/notFound/NotFound"));
// const CommingSoon = React.lazy(() => import("../../pages/comingSoon/ComingSoon"));

const Login = React.lazy(() => import("../../pages/auth/Login"));
const Register = React.lazy(() => import("../../pages/auth/Register"));
const VerifyOtp = React.lazy(() => import("../../pages/auth/VerifyOtp"));
const ForgotPassword = React.lazy(() => import("../../pages/auth/ForgotPassword"));
const ResetPassword = React.lazy(() => import("../../pages/auth/ResetPassword"));
const MyProfile = React.lazy(() => import("../../pages/auth/MyProfile"));
const AuthSuccess = React.lazy(() => import("../../pages/auth/AuthSuccess"));

const Main = () => {
    const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        const googTeGadge: any = document.getElementById('google_translate_element');
        if (googTeGadge) {
            googTeGadge.style.display = 'none';
        }
    }, [location]);

    return (
        <>
            <Routes>
                <Route element={<MainLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/:lang" element={<Home />} />
                    <Route path="/screen-reader-access" element={<ScreenReaderAccess />} />
                    <Route path="/sitemap" element={<Sitemap />} />
                    <Route path="/search/:search" element={<Search />} />
                    <Route path="/latest-events" element={<LatestEvents />} />
                    <Route path="/latest-events/:id" element={<LatestEventDetail />} />
                    <Route path="/photo-gallery-data-listing/pages/:slug" element={<PhotoGalleryDataListing />} />
                    <Route path="/photo-gallery" element={<PhotoGallery />} />
                    <Route path="/photo-gallery/:id" element={<PhotoGalleryDetail />} />
                    <Route path="/video-documentries" element={<VideoGallery />} />
                    <Route path="/press-releases" element={<PressReleases />} />
                    <Route path="/press-release/:id" element={<PressReleaseDetail />} />
                    <Route path="/corporate-song" element={<CorporateSong />} />
                    <Route path="/tenders" element={<Tenders />} />
                    <Route path="/tenders/:month/:year" element={<TenderDetail />} />
                    <Route path="/data-listing/pages/recruitment" element={<Recruitment category='recruitment' />} />
                    <Route path="/data-listing/pages/apprenticeship-training" element={<Recruitment category='apprenticeship-training' />} />
                    <Route path="/data-listing/pages/internal-selection-promotion" element={<Recruitment category='internal-selection-promotion' />} />
                    <Route path="/data-listing/pages/penal-action" element={<PenalAction />} />
                    <Route path="/data-listing/pages/:slug" element={<DataListing />} />
                    <Route path="/card-data-listing/pages/:slug" element={<CardDataListing />} />
                    <Route path="/feedback" element={<Feedback />} />
                    <Route path="/help" element={<Help />} />
                    {/* <Route path="/pages/safety-rescue-department" element={<SafetyRescueDepartment />} /> */}
                    <Route path="/pages/:slug" element={<Content />} />
                    {/*<Route path="/comming-soon" element={<CommingSoon />} />*/}

                    {isLogin ?
                        <>
                            <Route path="/my-profile" element={<MyProfile />} />
                        </>
                        :
                        <>
                            <Route path="/my-profile" element={<Navigate to="/login" replace />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/verify-otp" element={<VerifyOtp />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/account-created" element={<AuthSuccess type="register" />} />
                            <Route path="/password-reset-success" element={<AuthSuccess type="forgot-password" />} />
                        </>
                    }
                </Route>
                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
};

export default Main;